module.exports = __webpack_public_path__ + "media/images/articles/job_motivation/cover-6fba5625dd3cc634e41080bdc8a56ccf.png";